import currency from "currency.js";

/** NUB-450c: paid prices are locked. Mirrors ops-backend tax-exemption.rules. */
export enum InvoicePaymentStatus {
  Paid = "Paid",
  PartiallyPaid = "Partially Paid",
}

type InvoicePaymentState = {
  status?: string | null;
  // Currency scalar arrives as a string ("0" is truthy), so it must be parsed.
  amountPaid?: string | number | null;
};

export const isInvoicePaymentLocked = (invoice?: InvoicePaymentState | null): boolean => {
  if (!invoice) return false;
  return (
    currency(invoice.amountPaid ?? 0).value > 0 ||
    invoice.status === InvoicePaymentStatus.Paid ||
    invoice.status === InvoicePaymentStatus.PartiallyPaid
  );
};
